import script from "./CardTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./CardTitle.vue?vue&type=script&setup=true&lang=js"

import "./CardTitle.vue?vue&type=style&index=0&id=1ff93bca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff93bca"]])

export default __exports__